// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1FFhr","info":"PatientInfo_info__1cOWO"};